module.exports = __webpack_public_path__ + "img/BA5DBA_F2BEF2_E69BE6_DC8CDC-256px.3303cc75.png";